import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductsShop } from "../../redux/actions/product";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../redux/actions/wishlist";
import { addTocart } from "../../redux/actions/cart";
import Breadcrumbs from "../Layout/Breadcrumbs";
import ProductDetailsInfo from "./ProductDetailsInfo.jsx";
import { useToast } from "../Layout/Toast/ToastProvider.jsx";
import {
  AiFillHeart,
  AiOutlineHeart,
  AiOutlineLeft,
  AiOutlineRight,
  AiOutlineClose,
  AiOutlineExpand,
} from "react-icons/ai";
import "./ProductDetails.scss";

const ProductDetails = ({ data }) => {
  const { wishlist } = useSelector((state) => state.wishlist);
  const { cart } = useSelector((state) => state.cart);
  const { products } = useSelector((state) => state.products);
  const [selectedColor, setSelectedColor] = useState(null);
  const [hoveredColor, setHoveredColor] = useState(null);
  const [animate, setAnimate] = useState(false);
  const { showToast } = useToast();


  const [click, setClick] = useState(false);
  const [select, setSelect] = useState(0);
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(getAllProductsShop(data && data?.shop._id));
    if (wishlist && wishlist.find((i) => i._id === data?._id)) {
      setClick(true);
    } else {
      setClick(false);
    }
  }, [data, wishlist, dispatch]);

  const handleColorClick = (color) => {
    setSelectedColor(color);
  };

  const removeFromWishlistHandler = (data) => {
    setClick(!click);
    dispatch(removeFromWishlist(data));
  };

  const addToWishlistHandler = (data) => {
    setAnimate(true);
    setClick(!click);
    dispatch(addToWishlist(data));
    setTimeout(() => setAnimate(false), 400);
  };

  const addToCartHandler = (id) => {
    const itemIndex = cart.findIndex((i) => i._id === id);

    if (itemIndex !== -1) {
      const updatedItem = {
        ...cart[itemIndex],
        qty: cart[itemIndex].qty + 1,
      };
      dispatch(addTocart(updatedItem, itemIndex));
      showToast("Кількість товару в корзині збільшена!", "success");
    } else {
      const cartData = { ...data, qty: 1 };
      dispatch(addTocart(cartData));
      showToast("Продукт успішно додано до корзини!", "success");
    }
  };

  const handleNextImage = useCallback(() => {
    setSelect((prev) => (prev + 1) % data.images.length);
  }, [data?.images]);

  const handlePrevImage = useCallback(() => {
    setSelect((prev) => (prev - 1 + data.images.length) % data.images.length);
  }, [data?.images]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") {
        handleNextImage();
      } else if (e.key === "ArrowLeft") {
        handlePrevImage();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [select, handleNextImage, handlePrevImage]);

  const [startX, setStartX] = useState(null);

  const handleSwipeStart = (clientX) => {
    setStartX(clientX);
  };

  const handleSwipeMove = (clientX) => {
    if (startX !== null) {
      const distance = clientX - startX;
      if (distance > 50) {
        handlePrevImage();
        setStartX(null);
      } else if (distance < -50) {
        handleNextImage();
        setStartX(null);
      }
    }
  };

  const handleSwipeEnd = () => {
    setStartX(null);
  };

  const [isFullscreen, setIsFullscreen] = useState(false);

  const [isAnimating, setIsAnimating] = useState(false);

  const toggleFullscreen = () => {
    if (isFullscreen) {
      setIsAnimating(true);
      setTimeout(() => {
        setIsFullscreen(false);
        setIsAnimating(false);
      }, 400);
    } else {
      setIsFullscreen(true);
    }
  };
  return (
    <div className="productDetails">
      {data ? (
        <div className="productDetails__wrapper">
          <Breadcrumbs data={data} />
          <div className="productDetails__content">
            <div className="productDetails__imagesContainer">
              <div className="productDetails__leftBlock">
                <div
                  className="productDetails__mainImageWrapper"
                  onTouchStart={(e) => handleSwipeStart(e.touches[0].clientX)}
                  onTouchMove={(e) => handleSwipeMove(e.touches[0].clientX)}
                  onTouchEnd={handleSwipeEnd}
                  onMouseDown={(e) => handleSwipeStart(e.clientX)}
                  onMouseMove={(e) => handleSwipeMove(e.clientX)}
                  onMouseUp={handleSwipeEnd}
                  onMouseLeave={handleSwipeEnd}
                  onDragStart={(e) => e.preventDefault()}
                >
                  <img
                    src={data.images[select]?.url}
                    alt=""
                    className="productDetails__mainImage"
                  />
                  {!isFullscreen && (
                    <button
                      className={`productDetails__btn productDetails__expandBtn`}
                      onClick={toggleFullscreen}
                    >
                      <AiOutlineExpand size={24} />
                    </button>
                  )}
                  {isFullscreen && (
                    <div
                      className={`productDetails__fullscreen ${
                        isAnimating ? "scale-0" : "scale-100"
                      }`}
                    >
                      <button
                        className={`productDetails__btn productDetails__closeBtn`}
                        onClick={toggleFullscreen}
                      >
                        <AiOutlineClose size={22} />
                      </button>

                      <button
                        className={`productDetails__btn productDetails__prevBtn`}
                        onClick={handlePrevImage}
                      >
                        <AiOutlineLeft size={24} />
                      </button>

                      <div>
                        <img
                          src={data.images[select]?.url}
                          alt=""
                          className="productDetails__fullscreenImage"
                        />
                      </div>

                      <button
                        className={`productDetails__btn productDetails__nextBtn`}
                        onClick={handleNextImage}
                      >
                        <AiOutlineRight size={24} />
                      </button>

                      <div className="productDetails__thumbnailsWrapper">
                        {data.images.map((thumbnail, index) => (
                          <div
                            key={index}
                            onClick={() => setSelect(index)}
                            className={`productDetails__thumbnailItem ${
                              select === index ? "active" : ""
                            }`}
                          >
                            <img src={thumbnail.url} alt="" />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <button
                    onClick={handlePrevImage}
                    className={`productDetails__btn productDetails__prevBtn`}
                  >
                    <AiOutlineLeft size={24} />
                  </button>
                  <button
                    onClick={handleNextImage}
                    className={`productDetails__btn productDetails__nextBtn`}
                  >
                    <AiOutlineRight size={24} />
                  </button>
                </div>
                <div className="productDetails__bottomThumbnails">
                  {data.images.map((img, index) => (
                    <div
                      className="productDetails__thumbItem"
                      key={index}
                      onClick={() => setSelect(index)}
                    >
                      <img src={img.url} alt="" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="productDetails__infoBlock">
                <h1 className="productDetails__infoTitle">{data.name}</h1>

                {data.discountPrice ? (
                  // Якщо є discountPrice
                  <>
                    <div className="productDetails__priceLine">
                      <h3 className="productDetails__oldPrice">
                        {data.originalPrice.toLocaleString("uk-UA")} грн
                      </h3>
                    </div>
                    <div className="productDetails__priceBlock">
                      <h4 className="productDetails__discountPrice">
                        {data.discountPrice.toLocaleString("uk-UA")} грн
                      </h4>
                      <div
                        className={`productDetails__wishlistIcon ${
                          click ? "active" : ""
                        }`}
                      >
                        {click ? (
                      <AiFillHeart
                        onClick={() => removeFromWishlistHandler(data)}
                        title="Remove from wishlist"
                        style={{
                          animation: animate
                            ? "heartbeat 0.8s ease-in-out infinite"
                            : "none",
                        }}
                      />
                    ) : (
                      <AiOutlineHeart
                        onClick={() => addToWishlistHandler(data)}
                        title="Add to wishlist"
                      />
                    )}
                      </div>
                    </div>
                  </>
                ) : (
                  // Якщо discountPrice немає
                  <div className="productDetails__priceBlock">
                    <h4 className="productDetails__discountPrice">
                      {data.originalPrice.toLocaleString("uk-UA")} грн
                    </h4>
                    <div
                      className={`productDetails__wishlistIcon ${
                        click ? "active" : ""
                      }`}
                    >
                     {click ? (
                      <AiFillHeart
                        onClick={() => removeFromWishlistHandler(data)}
                        title="Remove from wishlist"
                        style={{
                          animation: animate
                            ? "heartbeat 0.8s ease-in-out infinite"
                            : "none",
                        }}
                      />
                    ) : (
                      <AiOutlineHeart
                        onClick={() => addToWishlistHandler(data)}
                        title="Add to wishlist"
                      />
                    )}
                    </div>
                  </div>
                )}

                {data.colors && data.colors.length > 0 && (
                  <div className="productDetails__colorsBlock">
                    <div>
                      <h4 className="productDetails__colorsLabel">Колір:</h4>
                      {data.colors.map((color, index) => (
                        <div
                          key={index}
                          className={`productDetails__colorSquare ${
                            selectedColor === color ? "selected" : ""
                          }`}
                          style={{
                            backgroundColor: color,
                          }}
                          onMouseEnter={() => setHoveredColor(color)}
                          onMouseLeave={() => setHoveredColor(null)}
                          onClick={() => handleColorClick(color)}
                        >
                          {hoveredColor === color && (
                            <div
                              className="productDetails__colorTooltip"
                              style={{ backgroundColor: color }}
                            >
                              <span>{color}</span>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <div className="productDetails__buttonsBlock">
                  <div
                    className="productDetails__button"
                    onClick={() => addToCartHandler(data._id)}
                  >
                    Оформити кредит
                  </div>
                  <div
                    className="productDetails__button"
                    onClick={() => addToCartHandler(data._id)}
                  >
                    Додати в кошик
                  </div>
                </div>
              </div>
            </div>
            <ProductDetailsInfo data={data} products={products} />
            <br />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ProductDetails;
